import { useEffect, useMemo } from 'react';
import { useAnalysisData } from '../../contexts/AnalysisDataContext';
import { AnalysisRange } from './useAnalysisRange';
import { runAllDetectors } from '../../utils/analytics/anomalyDetectors';
import { AnomalySeverity } from '../../utils/analytics/types';
import { getTodayString } from '../../utils/dateUtils';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export function useAnomalyAnalysis(range: AnalysisRange) {
  const { stays, payments, loading, error, ensureRange } = useAnalysisData();

  useEffect(() => {
    ensureRange(range.from, range.to);
  }, [range.from, range.to, ensureRange]);

  return useMemo(() => {
    const findings = runAllDetectors({
      stays,
      payments,
      today: getTodayString(),
      // In local/dev the sandbox gateway is expected — don't spam criticals
      expectedGatewayEnvironment: IS_PRODUCTION ? 'production' : undefined,
    }).filter(f => IS_PRODUCTION || f.type !== 'gateway_environment');

    const counts: Record<AnomalySeverity, number> = { critical: 0, serious: 0, warning: 0, info: 0 };
    for (const finding of findings) counts[finding.severity] += 1;

    return { loading, error, findings, counts };
  }, [stays, payments, loading, error]);
}
